import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import PropTypes from 'prop-types';
import { fontSize, fontWeight } from '@mui/system';
import { styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import { makeStyles } from '@mui/styles';


const BootstrapInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
        marginTop: theme.spacing(3),
    },
    '& .MuiInputBase-input ': {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 13.5,
        padding: '5px 26px 5px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '"Customfont"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: "none",
            // boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    }
}));

const useStyles = makeStyles({
    inputgroupaddon: {
        height: "22px",
        minWidth: "100px",
        width: "100px",
        padding: "2px",
        fontsize: "12px !important",
        fontWeight: "700",
        lineHeight: "1",
        color: "#555",
        textAlign: "center",
        backgroundColor: "#eee",
        border: "1px solid #ccc",
        borderRadius: "4px",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        display: "table-cell",
        borderCollapse: "separate",
        fontFamily: "Customfont !important",
    },
    inputgroupaddon1: {
        minWidth: '150px',
        height: "22px",
        width: "100px",
        padding: "2px",
        fontSize: "12px !important",
        fontWeight: "700",
        lineHeight: "1",
        // color: "#555",
        textAlign: "right",
        // backgroundColor: "#eee",
        border: "1px solid #ccc",
        borderRadius: "4px",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        display: "table-cell",
        borderCollapse: "separate",
        fontFamily: "Customfont !important",
    },
    inputGroup: {
        position: "relative",
        display: "table",
        borderCollapse: "separate",
        float: "none",
        paddingRight: 0,
        paddingLeft: 0,
        // marginBottom: "5px",
        // paddingLeft: "15px",
        // paddingRight: "15px"
    }
});


export default function BasicSelect(props) {

    const classes = useStyles(props);

    const { MenuItemlist, origin, title, defaultselect, opentitle } = props

    const [value, setvalues] = React.useState("");
    const [name, setname] = React.useState("");
    const [SaveMoney, setSaveMoney] = React.useState(classes.inputgroupaddon);

    const handleChange = (event) => {
        // console.log("PriceType_code handleChange",event.target.value)
        setvalues(event.target.value);
        if (event.target.value !== "") {
            props.valueSelect(event.target.value, event.target.name)
        }
        if (event.target.value === "") {
            props.valueSelect("", "")
        }
    };

    React.useEffect(() => {
        // console.log(origin, ":::::defaultselect:::::", defaultselect, "MenuItemlist", MenuItemlist, "::::useEffectdefaultselect");

        setDefaultvalue()
        return () => {
        }
    }, [defaultselect])


    React.useEffect(() => {
        if (props.popup) {
            setSaveMoney(classes.inputgroupaddon1)
        } else {
            setSaveMoney(classes.inputgroupaddon)
        }
        // console.log(props);
        // console.log(origin, ":::::defaultselect:::::", defaultselect, "MenuItemlist", MenuItemlist);
        return () => {
        }
    }, [])

    const setDefaultvalue = () => {
        setvalues(defaultselect)
        setname(title)
    }
    return (
        <FormControl fullWidth>
            <div className={classes.inputGroup}>
                {!opentitle ? <span className={SaveMoney} style={{ fontSize: "14px" }}>{title}</span> : ""}
                <Select
                    labelId={origin}
                    id={origin}
                    value={value}
                    name={name}
                    label={origin}
                    onChange={handleChange}
                    size="small"
                    sx={{ height: "32px", fontSize: "13px", border: '1', minWidth: "100%" }}
                    variant="standard"
                    input={<BootstrapInput />}
                >
                    {/* <MenuItem value="" sx={{ height: '30px' }}>  </MenuItem> */}
                    {MenuItemlist.length > 0 ? MenuItemlist.map((_, index) => (
                        <MenuItem key={MenuItemlist[index].id} value={MenuItemlist[index].id} sx={{ fontSize: "13.5px", fontFamily: "Customfont" }}>{MenuItemlist[index].value}</MenuItem>
                    )) : ""
                    }
                </Select>
            </div>

        </FormControl>

    );
}

BasicSelect.propTypes = {
    // You can declare that a prop is a specific JS primitive. By default, these
    // are all optional.
    MenuItemlist: PropTypes.array,
    origin: PropTypes.string,
    title: PropTypes.string,
    defaultselect: PropTypes.string,
    opentitle: PropTypes.bool
}
